export default class Workers {
    constructor(tasks, dispatcher) {
        this.dispatcher = dispatcher;
        this.setWorkers(tasks);
        this.createReducer();
    }

    setDispatcher(dispatcher) {
        this.dispatcher = dispatcher;
    }

    setWorkers(tasks) {
        tasks = tasks || {};

        this.methods = {};

        if (this.tasks) {
            this.tasks.forEach((task) => {
                if (task.destroy) {
                    task.destroy();
                }
            });
        }

        this.tasks = [];

        Object.keys(tasks).forEach((namespace) => {
            let actions = tasks[namespace];

            Object.keys(actions).forEach((action) => {
                if (!this.methods[action]) {
                    this.methods[action] = [];
                }

                this.methods[action].push({
                    namespace,
                    method: actions[action]
                });

                this.tasks.push(actions[action]);
            });
        });
    }

    createReducer() {
        const actionFired = ( action, state ) => {
            this.methods[ action.type ].forEach( ( task ) => {
                task.method( this.dispatcher, action, state );
            } );
        };

        this.reducer = (state, action) => {
            if (action && this.methods[action.type]) {
                setTimeout(actionFired.bind(this, action, state), 0);
            }

            return state;
        };
    }
}
